<template>
  <b-modal
    v-model="showModal"
    :close-title="resource['label.Close']"
    size="md"
    :centered="true"
    :title="resource['BeforeRemoveFileHeaderText']"
    title-tag="h2"
    @hidden="$emit('cancel')"
  >
    <div class="row">
      <div class="col">
        <!-- <div> -->
        <span>{{ resource['BeforeRemoveFileText'] }}</span>
        <!-- </div> -->
      </div>
    </div>
    <div slot="modal-footer">
      <button
      id="stayPageBtn"
      name="stayPageBtn"
      class="btn md bg-white  text-color-purple"
        @click="$emit('cancel')"
      >
      {{ resource['users.BeforeRemoveUserCancel'] }}
      </button>
      <button id="leavePageBtn"  class="btn md bg-purple text-white" @click="$emit('approve')">
        {{ resource['users.BeforeRemoveUserApprove'] }}
      </button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'CandidateRemoveWarning',

  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
  },
  created() {
  },

};
</script>

<style lang="scss" scoped>
:deep().modal-footer{
  border:none !important;
}
</style>
